import * as React from 'react';

interface PropsInterface {
  isVisible: boolean;
  classes?: string;
}

const Loader = ({ isVisible, classes }: PropsInterface): JSX.Element => (
  <div
    className={`default-loader ${isVisible ? 'is-visible' : ''} ${
      classes || ''
    } `}
  >
    Loading...
  </div>
);

export default Loader;
